import { useEffect, useState } from "react";
import { adminGetAudit } from "@/lib/api";

export default function AdminAudit() {
  const [items, setItems] = useState([]);
  useEffect(() => { adminGetAudit().then(setItems).catch(() => {}); }, []);
  return (
    <div data-testid="admin-audit">
      <p className="cv-kicker">Audit trail</p>
      <h1 className="cv-display text-3xl mt-4">Who changed what, and when.</h1>
      <div className="mt-8 divide-y divide-[rgba(28,27,25,0.14)] border-t border-[rgba(28,27,25,0.14)] max-w-2xl">
        {items.map((a) => (
          <div key={a.id} data-testid="admin-audit-row" className="py-4 flex items-start justify-between gap-4">
            <div>
              <p className="cv-body text-sm text-[#1F1B16]"><span className="cv-sans uppercase tracking-[0.1em] text-[0.68rem] text-[#A6633C]">{a.action}</span> {a.target}</p>
              {a.detail && <p className="cv-body text-xs text-[#9A938A] mt-1">{a.detail}</p>}
            </div>
            <div className="text-right shrink-0">
              <p className="cv-body text-xs text-[#1F1B16]/70">{a.who}</p>
              <p className="cv-body text-[0.7rem] text-[#9A938A]">{new Date(a.at).toLocaleString()}</p>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="cv-body text-sm text-[#9A938A] py-4">No changes recorded yet.</p>}
      </div>
    </div>
  );
}
